import React from "react";
import { Link, useParams } from "react-router-dom";
import "./Test.css";

export default function Test() {
  let { test_id } = useParams();
  let { subject_id } = useParams();
  if (test_id){
    return (
      <div>
        <div className="container">
          <div className="text-name">
          </div>
          <div className="text-box">
            <div className="test-home">
              <div className="test-box">
                <p> Test ishlashni xohlaysizmi?</p>
                <Link to={`/savol/${test_id}/${subject_id}`} className="btn">
                  Boshlash
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );

  }else{
    return (
      <div>
        <div className="container">
          <div className="text-name">
          </div>
          <div className="text-box">
            <div className="test-home">
              <div className="test-box">
                <p> Test ishlashni xohlaysizmi?</p>
                <Link to={`/savollar/`} className="btn">
                  Boshlash
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

}
